export default {"src":"/_next/static/media/icon-youtube.a35d20cc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};